import React, { useContext, useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { Avatar } from 'react-native-elements';

import { Context as ArtistsContext } from '../context/ArtistsContext';
import Accordion from '../components/Accordion';
import MaskedImageContainer from '../components/MaskedImageContainer';
import { FlatList } from 'react-native-gesture-handler';

const styles = StyleSheet.create({
  header: {
    paddingLeft: 20,
    flexDirection: 'row',
    alignItems: 'center',
  },
  artistName: { margin: 20, fontSize: 20 },
  content: { alignItems: 'center', padding: 20 },
  profile: {},
});

const renderSingleArtist = ({ item }) => {
  const { id, content } = item;
  return (
    <Accordion
      key={id}
      renderHeader={() => {
        return (
          <View style={styles.header}>
            <Avatar rounded source={{ uri: content.avatarImageUrl }} />
            <Text style={styles.artistName}>{content.kanjiName}</Text>
          </View>
        );
      }}
      renderContent={() => {
        return (
          <View style={styles.content}>
            <MaskedImageContainer
              uri={content.profileImageUrl}
              imageProportionType="a4"
              imageWidthRelativeToDeviceWidth={0.7}
              maskWidthRelativeToDeviceWidth={0.7}
              maskHeightRelativeToDeviceWidth={0.7}
              containerWidthRelativeToDeviceWidth={0.8}
              containerHeightRelativeToDeviceWidth={0.8}
            />
            <Text style={styles.profile}>{content.profile}</Text>
          </View>
        );
      }}
    />
  );
};

export default function ArtistsScreen() {
  const { state, fetchArtistsAction } = useContext(ArtistsContext);
  useEffect(() => {
    fetchArtistsAction();
  }, []);

  return (
    <FlatList
      data={state}
      key={(item) => item.id}
      renderItem={renderSingleArtist}
    />
  );
}
